import { css } from 'styled-components';
import { BaseButtonProps } from 'types';
import { buttonBorderRadiusBySizeDecorator } from 'utils';
import { outlined } from './outlined';

export const roundOutlined = ({ background, ...rest }: BaseButtonProps) => css`
	${outlined(rest)}
	${buttonBorderRadiusBySizeDecorator(rest)}
`;
